import { motion } from "framer-motion";
import { Users, MessageCircle, Sparkles } from "lucide-react";
import { useLang } from "@/i18n";
import { waLink } from "@/api";

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 30 }, whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" }, transition: { duration: 0.8, delay },
});

export default function Retreats({ config }) {
  const { t } = useLang();
  const items = t("ret.items");
  const wa = config?.whatsapp || "40721663181";

  return (
    <section id="retreats" className="py-24 md:py-32 bg-cream-light border-y border-warm-grey/30" data-testid="retreats-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <motion.p {...fadeUp()} className="text-xs md:text-sm tracking-[0.25em] uppercase font-bold text-walnut flex items-center gap-3">
          <span className="inline-block w-10 h-px bg-terracotta" />
          {t("ret.eyebrow")}
        </motion.p>
        <motion.h2 {...fadeUp(0.1)} className="mt-5 font-serif font-medium text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-main max-w-3xl">
          {t("ret.title")}
        </motion.h2>
        <motion.p {...fadeUp(0.15)} className="mt-6 text-brown/80 font-light leading-relaxed max-w-2xl">
          {t("ret.sub")}
        </motion.p>

        <motion.div {...fadeUp(0.2)} className="mt-10 overflow-hidden rounded-3xl border border-warm-grey/40 shadow-xl shadow-main/5">
          <img src="/assets/retreats-events.jpg" alt="Retreats & Camp & Events la Imperfect House — corporate, tabere creative, foc de seară" loading="lazy"
            className="w-full h-auto" data-testid="retreats-image" />
        </motion.div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((item, i) => (
            <motion.article key={item.t} {...fadeUp(0.1 + (i % 3) * 0.1)}
              className="bg-cream border border-warm-grey/40 rounded-3xl p-7 hover:border-terracotta/50 hover:shadow-xl hover:shadow-terracotta/5 transition-all duration-300"
              data-testid={`retreat-card-${i}`}>
              <Sparkles size={20} className="text-terracotta" />
              <h3 className="mt-4 font-serif text-2xl text-main">{item.t}</h3>
              <p className="mt-3 text-sm text-brown/85 font-light leading-relaxed">{item.d}</p>
            </motion.article>
          ))}
        </div>

        <motion.div {...fadeUp(0.2)} className="mt-10 bg-cream border border-warm-grey/40 rounded-3xl p-7 md:p-8 flex flex-col md:flex-row md:items-center gap-6" data-testid="retreats-capacity">
          <div className="flex items-start gap-3 flex-1">
            <Users size={20} className="text-green-dark shrink-0 mt-0.5" />
            <p className="text-sm text-brown/85 font-light leading-relaxed">{t("ret.capacity")}</p>
          </div>
          <a href={waLink(wa, t("ret.wa_msg").replace("{type}", "retreat / eveniment"))} target="_blank" rel="noreferrer"
            data-testid="retreats-cta"
            className="shrink-0 inline-flex items-center justify-center gap-2 rounded-full bg-terracotta text-cream-light font-semibold px-7 py-3.5 hover:bg-terracotta/90 transition-all duration-300">
            <MessageCircle size={17} /> {t("ret.cta")}
          </a>
        </motion.div>
      </div>
    </section>
  );
}
